<template>
  <textarea
    class="
      !border
      border-gray-100
      outline-none
      text-md
      px-3
      py-2
      placeholder-gray-600
      disabled:bg-gray-100
      min-h-[7rem]
    "
    v-model="model"
  />
</template>

<script>
export default {
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
